export const SET_SIDE = 'SET_SIDE';

export const setYourSide = (side) => {
  return {
    type: SET_SIDE, 
    side: side,
  }
};